import { render, staticRenderFns } from "./PartnersPhoneText.vue?vue&type=template&id=6216b06c&scoped=true&"
var script = {}
import style0 from "./PartnersPhoneText.vue?vue&type=style&index=0&id=6216b06c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6216b06c",
  null
  
)

export default component.exports